// extracted by mini-css-extract-plugin
export default {"header":"Table_header__H1YF3","link":"Table_link__m2Yiq","active":"Table_active__NdpWo","inactive":"Table_inactive__Hwx8o"};